import axios from 'axios';
import { Ride, RideType, RideStatus } from '../types/ride';

const API_BASE_URL = `${process.env.REACT_APP_ORDERS_SERVICE_BASE_URL}/api/v1`;

export interface RideFilters {
  page: number;
  limit: number;
  ride_type?: RideType;
  ride_status?: RideStatus;
  filter_type?: 'daily' | 'weekly' | 'monthly' | 'custom';
  start_date?: string;
  end_date?: string;
}

export interface ApiResponse<T> {
  status: boolean;
  data: T;
}

export interface PaginatedResponse<T> {
  rides: T[];
  pagination: {
    total: number;
    page: number;
    limit: number;
    total_pages: number;
  };
}

export const rideApi = {
  getRides: async (filters: RideFilters): Promise<PaginatedResponse<Ride>> => {
    try {
      const response = await axios.get<ApiResponse<PaginatedResponse<Ride>>>(`${API_BASE_URL}/admin/rides`, {
        params: filters,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching rides:', error);
      throw error;
    }
  },

  getRideDetails: async (rideId: string): Promise<Ride> => {
    try {
      const response = await axios.get<ApiResponse<{ ride: Ride }>>(`${API_BASE_URL}/admin/rides/${rideId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data.data.ride;
    } catch (error) {
      console.error('Error fetching ride details:', error);
      throw error;
    }
  },

  getRidesCount: async (filters: {
    start_date?: string;
    end_date?: string;
    filter_type?: string;
  }): Promise<{ count: number }> => {
    try {
      const response = await axios.get<ApiResponse<{ count: number }>>(`${API_BASE_URL}/admin/rides/count`, {
        params: filters,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching rides count:', error);
      throw error;
    }
  },
}; 